/* Top Shot Players — interactions */
(function () {
  "use strict";

  /* Mobile/tablet nav dropdown */
  var toggle = document.querySelector(".nav-toggle");
  var links = document.querySelector(".nav-links");

  function closeNav() {
    if (!links) return;
    links.classList.remove("open");
    if (toggle) {
      toggle.classList.remove("open");
      toggle.setAttribute("aria-expanded", "false");
    }
  }

  if (toggle && links) {
    toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = links.classList.toggle("open");
      toggle.classList.toggle("open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    links.addEventListener("click", function (e) {
      if (e.target.tagName === "A") closeNav();
    });
    document.addEventListener("click", function (e) {
      if (links.classList.contains("open") && !links.contains(e.target)) closeNav();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeNav();
    });
  }

  /* Scroll reveal */
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in-view"); });
  }

  /* Count-up stats (data-count="21" data-suffix="M+") */
  var counters = document.querySelectorAll("[data-count]");
  if ("IntersectionObserver" in window && counters.length) {
    var cio = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          cio.unobserve(entry.target);
          var el = entry.target;
          var target = parseFloat(el.getAttribute("data-count"));
          var suffix = el.getAttribute("data-suffix") || "";
          var dur = 1400;
          var start = null;
          function tick(ts) {
            if (!start) start = ts;
            var p = Math.min((ts - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.childNodes[0].nodeValue = Math.round(target * eased);
            if (p < 1) requestAnimationFrame(tick);
          }
          el.innerHTML = "0<span class=\"suffix\">" + suffix + "</span>";
          requestAnimationFrame(tick);
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* Product gallery thumbnails */
  var mainImg = document.querySelector(".product-gallery .main-img");
  var thumbs = document.querySelectorAll(".thumb-row img");
  if (mainImg && thumbs.length) {
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        thumbs.forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
        mainImg.src = t.getAttribute("data-full") || t.src;
        mainImg.alt = t.alt;
      });
    });
  }

  /* Sticky mobile buy bar: show once the in-page CTA scrolls out of view */
  var buyBar = document.querySelector(".buy-bar");
  var inlineCta = document.querySelector(".product-cta");
  if (buyBar && inlineCta) {
    document.body.classList.add("has-buy-bar");
    var updateBuyBar = function () {
      buyBar.classList.toggle("visible", inlineCta.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener("scroll", updateBuyBar, { passive: true });
    window.addEventListener("resize", updateBuyBar, { passive: true });
    updateBuyBar();
  }
})();

/* ---------- Viral video cards + media carousel ---------- */
(function () {
  "use strict";

  /* Play-button overlay for any video card */
  document.querySelectorAll("[data-video-card]").forEach(function (card) {
    var video = card.querySelector("video");
    var overlay = card.querySelector(".mc-play");
    if (!video || !overlay) return;

    overlay.addEventListener("click", function (e) {
      e.stopPropagation();
      if (card.classList.contains("pos-left") || card.classList.contains("pos-right")) return;
      card.classList.add("is-playing");
      video.setAttribute("controls", "");
      video.play();
      if (window.tspTrack) window.tspTrack("video_played", { video: (video.currentSrc || video.src || "").split("/").pop() });
    });

    video.addEventListener("ended", function () {
      card.classList.remove("is-playing");
      video.removeAttribute("controls");
      video.currentTime = 0;
      if (window.tspTrack) window.tspTrack("video_ended", { video: (video.currentSrc || video.src || "").split("/").pop() });
    });
  });

  /* Infinite 3-up coverflow carousel */
  var carousel = document.querySelector("[data-carousel]");
  if (!carousel) return;

  var stage = carousel.querySelector(".mc-stage");
  var items = Array.prototype.slice.call(carousel.querySelectorAll(".mc-item"));

  function getByPos(pos) {
    return items.filter(function (i) { return i.classList.contains("pos-" + pos); })[0];
  }

  function stopVideo(item) {
    var v = item.querySelector("video");
    if (!v) return;
    if (!v.paused) v.pause();
    v.removeAttribute("controls");
    item.classList.remove("is-playing");
  }

  function rotate(dir) {
    var left = getByPos("left");
    var center = getByPos("center");
    var right = getByPos("right");
    if (!left || !center || !right) return;
    stopVideo(center);
    if (dir === "next") {
      right.classList.replace("pos-right", "pos-center");
      center.classList.replace("pos-center", "pos-left");
      left.classList.replace("pos-left", "pos-right");
    } else {
      left.classList.replace("pos-left", "pos-center");
      center.classList.replace("pos-center", "pos-right");
      right.classList.replace("pos-right", "pos-left");
    }
    if (window.tspTrack) window.tspTrack("carousel_browsed", { dir: dir });
  }

  carousel.querySelector(".mc-next").addEventListener("click", function () { rotate("next"); });
  carousel.querySelector(".mc-prev").addEventListener("click", function () { rotate("prev"); });

  /* Click a side card to bring it center */
  items.forEach(function (item) {
    item.addEventListener("click", function () {
      if (item.classList.contains("pos-left")) rotate("prev");
      else if (item.classList.contains("pos-right")) rotate("next");
    });
  });

  /* Swipe support */
  var startX = null;
  stage.addEventListener("pointerdown", function (e) { startX = e.clientX; });
  stage.addEventListener("pointerup", function (e) {
    if (startX === null) return;
    var dx = e.clientX - startX;
    if (Math.abs(dx) > 48) rotate(dx < 0 ? "next" : "prev");
    startX = null;
  });
})();
